<template>
    <div>
        <b-modal id="removeChild" ok-title="Ja, Kind abmelden" cancel-variant="link" footer-class="yes-no"
                 cancel-title="Abbrechen" @ok="removeChild(emailParent, selectedChild.membershipNumber)">
            <h2 class="text-center">Kind abmelden</h2>
            <h5 class="text-center">Du möchtest dieses Kind endgültig vom McDonald’s Junior Club abmelden?</h5>

            <div v-if="lastChild" class="alert alert-primary">
                Hinweis: Durch das Abmelden dieses Kindes wird deine gesamte Mitgliedschaft beim McDonald's Junior Club
                beendet.<br/>

                Hol dir unsere App - hier warten tolle Angebote und News auf dich!
                <div class="row mt-15">
                    <div class="col-6"><a href="https://itunes.apple.com/de/app/mcdonalds-deutschland/id524943492?mt=8"><img
                            src="assets/images/app-store.svg" alt=""></a></div>
                    <div class="col-6"><a
                            href="https://play.google.com/store/apps/details?id=de.mcdonalds.mcdonaldsinfoapp"><img
                            src="assets/images/google-play.svg" alt=""></a></div>
                </div>
            </div>

        </b-modal>
    </div>
</template>
<script>
    import {apiRemoveChild} from '../utils/api';

    export default {
        name: 'profileRemoveChildComponent',
        props: {
            emailParent: {
              type: String,
              default: ''
            },
            selectedChild: {},
            lastChild: {
              type: Boolean,
              default: false
            }
        },
        methods: {
            removeChild: function (email, child) {

                this.$store.commit('updateProfileRemoveChild', child);

                apiRemoveChild({
                    'email': email,
                    'membershipNumber': child
                })
                    .then(response => {
                        //this.removeChildResponse = response.data;

                        let code = response.data.code;

                        if (code === 2)
                            this.toast('Abmeldung des Kindes fehlgeschlagen. Bitte versuchen Sie es später erneut.')
                        else if (code === 0) {

                            this.$toasted.success('Das Kind wurde erfolgreich abgemeldet', {
                                duration: 3000,
                                position: 'bottom-right'
                            });

                            if (this.lastChild) {
                                this.$store.commit('login', false);
                                this.$store.commit('user', {email: '', password: ''});
                                window.location = 'https://www.mcdonalds.de/familien/junior-club';
                            }

                        } else if (code === 1)
                            this.toast('E-Mail-Adresse unbekannt')
                        else if (code === 1)
                            this.toast('Pflichtfeld nicht ausgefüllt')
                        else
                            this.toast(response.data.message);

                    })
                    .catch(e => {
                        this.$store.commit('error', e);
                    });

            },
            toast(text) {
                this.$toasted.error(text, {
                    duration: 3000,
                    position: 'bottom-right'
                });
            },
        }
    };
</script>
